import { Button, Upload } from "antd";
import React from "react";
import Swal from "sweetalert2";
import { ImageUploader } from "../../Components/Organizer/Event/Components/ImageUploader";

const MediaUploader = ({
  children,
  setmedia,
  media,
  mediaType,
  setuploadingMedia,
  setLuploading,
  border,
  setIsFileRemoved
}) => {
  // action: 'https://www.mocky.io/v2/5cc8019d300000980a055e76',

  const onChange = (f) => {
    const file = f.file;
    if (setIsFileRemoved) setIsFileRemoved(true);
    setLuploading(true);
    // Check for existing media type conflicts
    const existingMediaType = media.length > 0 ? media[0].type : null;
    if (existingMediaType && existingMediaType !== mediaType) {
      setuploadingMedia("error");
      Swal.fire({
        icon: "error",
        title: `Cannot upload ${mediaType}s along with ${existingMediaType}s. Please remove the existing media first.`
      });
      setLuploading(false);
      return;
    }

    if (file.status !== "uploading" || file.status === "done") {
      setLuploading(false);
      if (file?.type.includes(mediaType)) {
        if (media.length === 5) {
          setuploadingMedia("error");
          Swal.fire({
            icon: "error",
            title: "Connot post more then 5 files"
          });
          setLuploading(false);
        } else {
          const newMedia = {
            file: file.originFileObj,
            type: mediaType,
            preview: URL.createObjectURL(file.originFileObj)
          };
          setmedia((prev) => [...prev, newMedia]);
          setuploadingMedia(mediaType);
          setLuploading(false);
        }
      } else {
        setuploadingMedia("error");
        Swal.fire({
          icon: "error",
          title: "Invalid file type, Please only select image or video"
        });
      }
    } else if (file.status === "error") {
      setLuploading(false);
    }
  };

  if (mediaType === "image") {
    return (
      <ImageUploader imageType="newsFeed" onChange={onChange} defaultConfig={true}>
        <Button
          className={`TimelineUploadButton ${border && "noMinWidth"}`}
          style={{
            border: "none",
            boxShadow: "none",
            userSelect: "none"
          }}>
          {children}
        </Button>
      </ImageUploader>
    );
  } else {
    return (
      <Upload multiple onChange={onChange} showUploadList={false} accept={"video/*"}>
        <Button
          className={`TimelineUploadButton ${border && "noMinWidth"}`}
          style={{
            border: "none",
            boxShadow: "none",
            userSelect: "none"
          }}>
          {children}
        </Button>
      </Upload>
    );
  }
};

export default MediaUploader;
